import React, { FC } from "react";
import styles from "common/SearchProductPreview/SearchProductPreview.module.scss";
import Search from "assets/icons/search.svg";
import SadFace from "assets/icons/sad.svg";
import { cn } from "helpers/style";

type Props = {
  text?: string;
  sadFace?: boolean;
  className?: string;
};

const SearchRequestPreview: FC<Props> = ({
  text,
  sadFace,
  className,
}: Props) => {
  return (
    <div className={cn([styles.searchProductPreview, className])}>
      <div className={styles.searchProductPreviewImageContainer}>
        {sadFace ? <SadFace /> : <Search />}
      </div>
      <div className={styles.searchProductPreviewInner}>
        <p className={styles.searchProductPreviewTitle}>
          {text || "По вашему запросу ничего не найдено..."}
        </p>
      </div>
    </div>
  );
};

export default SearchRequestPreview;
